// extracted by mini-css-extract-plugin
export default {"dropboxIcon":"kB9niC"};